import PropTypes from "prop-types";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";

function PhotoViewer({ images }) {
  return (
    <PhotoProvider loop={true}>
      <div className="row justify-content-center">
        {images &&
          images.map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-xl-4 p-3">
              <PhotoView src={item.imageUrl}>
                <img src={item.imageUrl} alt={item.title} className="w-100" />
              </PhotoView>
            </div>
          ))}
      </div>
    </PhotoProvider>
  );
}

PhotoViewer.propTypes = {
  images: PropTypes.array.isRequired
};

export default PhotoViewer;
